import { Divider, Stack, Switch, TextInput } from '@mantine/core'
import { CompletionForm } from './CompletionForm'
import { TaskForm } from './TaskForm'
import { TaskDetailsProps } from './types'

export function TaskDetails({
  task,
  taskData,
  onTaskDataChange,
  completionData,
  onCompletionDataChange,
  markAsCompleted,
  onMarkAsCompletedChange,
  disabled = false,
  attachments,
}: TaskDetailsProps) {
  const isNewTask = !task?.id

  return (
    <Stack gap="lg">
      {/* Title - always first */}
      <TextInput
        label="Tehtävän otsikko"
        placeholder="Esim. Ikkunoiden pesu"
        value={taskData.name}
        onChange={(e) =>
          onTaskDataChange({ ...taskData, name: e.currentTarget.value })
        }
        required
        disabled={disabled}
      />

      {/* Mark as Completed Toggle */}
      <Switch
        size="md"
        label="Tehtävä on jo tehty"
        checked={markAsCompleted}
        onChange={(event) =>
          onMarkAsCompletedChange(event.currentTarget.checked)
        }
        disabled={disabled}
      />

      {/* Completion Form - show first when marking as completed */}
      {markAsCompleted && (
        <>
          <CompletionForm
            data={completionData}
            onChange={onCompletionDataChange}
            errors={undefined}
            disabled={disabled}
          />
          <Divider />
        </>
      )}

      {/* Task Form (without title) */}
      <TaskForm
        data={taskData}
        onChange={onTaskDataChange}
        errors={undefined}
        disabled={disabled}
        attachments={attachments}
        targetSeason={task?.targetSeason}
        markAsCompleted={markAsCompleted}
        isNewTask={isNewTask}
        hideTitle={true}
      />
    </Stack>
  )
}
